import cn from "classnames";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import styles from "../Front.module.sass";
import Confirm from "../../../components/Confirm";
import cusHomePage from "../../../i11/CustomizeHomePage";

import { UseApi } from "../../../hooks/use-api";
import { useUser } from "../../../context";
import { DeleteBanner } from "../../../Services/lib/admin";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { UseDisclosure } from "../../../hooks/use-disclosure";

const ImageC = ({ item, halfSize, open, reload, disabled }) => {
	const { locale } = useUser();

	const {
		isOpen: confirmV,
		onClose: confirmC,
		onOpen: confirmO,
	} = UseDisclosure();

	const [{ isLoading }, deleteBanner] = UseApi({
		service: DeleteBanner,
	});
	const onConfirm = async () => {
		const res = await deleteBanner(item._id);
		if (res) {
			ToastEmitter({
				msg: "Banner deleted",
				type: "success",
			});
			reload();
		}
	};
	return (
		<>
			<div
				className={cn(styles.card, disabled && styles.disabled)}
				style={{ width: halfSize ? "50%" : "100%" }}
			>
				<img className={styles.imageStyle} src={item.image} alt="_bannarIMG" />
				<div className={styles.imageCom}>
					<div className={styles.textStyle}>{item.title}</div>
					<button>{cusHomePage[locale].shop_now}</button>
				</div>
				<div className={styles.hoverEdit}>
					<button onClick={confirmO} type="button">
						<Icon size="24" name="trash" fill="white" />
					</button>
					<button onClick={() => open(item)} type="button">
						<Icon size="24" name="edit" fill="white" />
					</button>
				</div>
			</div>

			<Modal visible={confirmV} onClose={confirmC}>
				<Confirm
					title={"delete"}
					onCancel={confirmC}
					onConfirm={onConfirm}
					isLoading={isLoading}
				/>
			</Modal>
		</>
	);
};

export default ImageC;
